<template>
  <div>
    <ProfilData />
    <template v-if="$route.meta.showUpdatePasswordDialog">
      <PasswordDialog />
    </template>
  </div>
</template>
<script>
  import ProfilData from '../components/myProfile/ProfilData';
  import PasswordDialog from '../components/myProfile/PasswordDialog';

  export default {
    components: { ProfilData, PasswordDialog },
  };
</script>
